<template>
  <div>
    <div class="gl_listWrapBar"
         @click="tojourdetail(item)"
         v-for="(item,index) in datapageList.slice(0,5)"
         :key="index">
      <a href="#"
         class="gl_listItem">
        <div class="gl_listItemTitle gl_ltStyle_line">
          {{item.title}}
        </div>
        <div class="gl_listItemSub">
          {{item.abstracts}}
        </div>
        <div class="display_between marginTop10">
          <div>
            <span class="fontBold">关键词：</span>
            <!-- <span class="gl_gree_block" v-for="(itemn,index) in item.labelname" :key="index"  >{{delHtmlTag(itemn)}}</span> -->
            <span v-bind:class="calculate(indexn)"
                  class="gl_gree_block"
                  v-for="(itemN,indexn) in (biaoqianFormat(item.labelname)).split('；')"
                  :key="'0'+indexn">{{delHtmlTag(itemN)}}</span>
          </div>
          <div class="gl_inforshow">
            <span>{{formatTime(item.ptime,'YYYY/MM/DD')}}</span>
            <!--   <span><img src="/image/index/chakan.png">{{item.seeNum}}</span> -->
          </div>
        </div>
      </a>
    </div>

  </div>
</template>

<script>
import format from '@/assets/unit/unit.js'
export default {
  name: "inTagLite",
  props: ['datapageList'],
  data () {
    return {
      colorList: ['gl_gree_block', 'gl_red_block', 'gl_blue_block'],
    }
  },
  created () {

  },
  methods: {
    formatTime (datatime, timeformat) {
      return format(datatime, timeformat)
    },
    calculate (index) {
      var nm = this.colorList[Math.floor(index % 3)]
      return nm
    },
    /**tianlianpei */
    biaoqianFormat (val) {
      return val
        .replace(/<[^>]+>/g, '')
        .replace(/&mdash;/g, '')
        .replace(/&ldquo;/g, '')
        .replace(/&rdquo;/g, '')
        .replace(/&gamma;/g, '')
        .replace(/&beta;/g, '')
        .replace(/#br#/g, '')
        .replace(/&quot;/g, '')
        .replace(/&kappa;/g, '')
        .replace(/&nbsp;/g, '')
        .replace(/\|/g, '；')
    },
    textFormat (val) {
      return val
        .replace(/<[^>]+>/g, '')
        .replace(/&mdash;/g, '')
        .replace(/&ldquo;/g, '')
        .replace(/&rdquo;/g, '')
        .replace(/&gamma;/g, '')
        .replace(/&beta;/g, '')
        .replace(/#br#/g, '')
        .replace(/&quot;/g, '')
        .replace(/&kappa;/g, '')
        .replace(/&nbsp;/g, '')
    },
    delHtmlTag (str) {
      return str.replace(/<[^>]+>/g, '') //去掉所有的html标记
    },
    // tojourdetail(item) {
    tojourdetail (item) {
      const { href } = this.$router.resolve({
        path: '/journal/magazinejournal/magazinejournaldetail',
        query: {
          nian: item.nian,
          qi: item.qi,
          id: item.id,
        },
      })
      window.open(href, '_blank')
    },
  }
}
</script>

<style scoped>
.gree_block,
.red_block,
.blue_block {
    display: inline-block;
    padding: 4px 5px 2px 5px;
    font-size: 12px;
    margin-right: 5px;
    height: 20px;
}

.gree_block {
    border: 1px solid #469a97;
    color: #469a97;
}
</style>
